<template>

    <section class="course">
        {{weekChange}} {{timelineEvents}}

        <timeline></timeline>
        <div v-if="course">

            <div class="col-sm-12">
                <h1>{{course.name}}</h1>
                <span class="instructor-name">by {{instructors}}</span>
                <div class="course-description">
                    <div v-html="course.description"></div>
                </div>
                <div class="panel week-at-a-glance">
                    <div class="panel-heading"><h2>Week at a Glance<i class="clippie fa fa-info-circle" v-tooltip="'See all weekly events for this course. The table below will show you what this course contains: title, description, video lesson, feedback and live session archive'"></i></h2></div>
                    <div class="panel-body">

                        <div class="row text-center">
                            <p class="text-center">
                                <ul class="clearfix">
                                    <li class="weekday"
                                        v-for="weekday in weekdays"
                                        v-bind:class="dayBackground(weekday.abbreviation)">
                                        <div>
                                            {{weekday.name}}
                                            <span
                                                @click="goToEvent(event(weekday.abbreviation))"
                                                v-if="hasEvent(weekday.abbreviation)"
                                                class="pin" v-bind:class="event(weekday.abbreviation).type"></span>
                                        </div>
                                    </li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">

                <ul class="course-weeks clearfix panel" id="course-weeks" v-if="meetings && videos">
                    <li
                        v-for="(video, index) in videos"
                        class="row"
                        :id="'week-' + index"
                        :style="{'background-color': backgroundColor(video.color, index)}"
                        :class="{'current-week': video.week === currentWeek}">

                        <div class="col-md-2 toggle-week" @click="toggleRow(index)">
                            <i v-if="rowsToShow.indexOf(index) > -1" class="fa fa-minus"></i>
                            <i v-if="rowsToShow.indexOf(index) === -1" class="fa fa-plus"></i>
                            Week {{video.week}}
                        </div>

                        <div class="col-md-4">
                            <h4>{{video.title}}</h4>
                            <div v-show="rowsToShow.indexOf(index) > -1" class="description">{{video.summary}}</div>
                        </div>

                        <div class="col-md-2">
                            <router-link
                                v-if="video.video_chapters
                                && video.video_chapters[0]
                                && (video.weekAvailable <= currentWeek || new Date(term.endDate) < new Date() || localStorage.user_id == '4' || localStorage.user_id == '333')"
                                :to="{ name: 'videoPlayer', query: {week: video.week}, params: { instanceId: instanceId, videoId: video.id } }">
                                <img class="view-video" src="../assets/img/play-button-small-blue.png">View Video
                            </router-link>
                            <div v-show="rowsToShow.indexOf(index) > -1">
                                <router-link
                                    v-if="video.video_chapters
                                    && video.video_chapters[0]
                                    && (video.weekAvailable <= currentWeek || new Date(term.endDate) < new Date() || localStorage.user_id == '4' || localStorage.user_id == '333')"
                                    :to="{ name: 'videoPlayer', query: {week: video.week}, params: { instanceId: instanceId, videoId: video.id } }">
                                    <div class="video-thumbnail" >
                                        <img :src="video.video_chapters[0].thumbnail">
                                        <img class="play-button" src="../assets/img/play-button.png">
                                    </div>
                                </router-link>
                            </div>
                        </div>

                       <div class="col-md-2">
                            <div v-if="assignments && hasAssignment(video)">
                                <a v-if="assignments && hasFeedback(video)" @click="playFeedback(video.week)">
                                    <img class="view-video" src="../assets/img/play-button-small-green.png">
                                </a>
                                <img v-else class="view-video inactive" src="../assets/img/play-button-small-grey.png">

                                <a v-if="assignments && hasFeedback(video.week)" @click="playFeedback(video.week)">Feedback</a>

                                <a v-else class="inactive">Feedback</a>
                            </div>
                            <div v-show="rowsToShow.indexOf(index) > -1" v-if="assignments && hasFeedback(video.week)">
                                <div @click="playFeedback(video.week)" class="video-thumbnail">
                                    <img src="../assets/img/feedback-thumb.jpg">
                                    <img class="play-button" src="../assets/img/play-button.png">
                                </div>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <a v-if="meetingForWeek(video.week)" :href="meetingForWeek(video.week).archiveUrl" target="_blank">
                                Live Session
                                <span v-if="meetingForWeek(video.week).secondaryRecordings && meetingForWeek(video.week).secondaryRecordings.length > 0">
                                    (
                                    <a :href="meetingForWeek(video.week).archiveUrl" target="_blank" class="recording">1</a>
                                     <span v-for="(recording, index) in meetingForWeek(video.week).secondaryRecordings">,
                                        <a :href="recording" target="_blank" class="recording"> {{ index + 2 }} </a>
                                    </span>)
                                </span>
                            </a>
                            <a v-else class="inactive">Live Session</a>
                        </div>

                    </li>
                </ul>
            </div>

        </div>

        <div class="panel col-sm-12 has-course-table" v-if="course && assignments">

            <div class="panel-heading assignments"><h2><img src="../assets/img/assignment-icon.png">Assignments<i class="clippie fa fa-info-circle" v-tooltip="'A sortable assignment table including due dates, marks and recorded feedback.'"></i></h2></div>
            <div class="panel-body">
                <assignments-table :assignments="assignments"></assignments-table>




            </div>

        </div>

        <!--
        TODO: replace this with new forum content.
        <discussion></discussion>
        -->


        </div>

        </div>

    </section>


</template>


<script>
    import router from '../router';

    import terms from '../services/terms';

    import courseCountdown from './reusable/course-countdown/individual';
    import assignmentCountdown from './reusable/assignment-countdown';
    import videoComment from './reusable/discussion/VideoComment.vue';
    import feedback from './reusable/feedback/Feedback.vue';
    import timeline from './widgets/Timeline.vue';
    import discussion from './Discussion.vue';
    import assignmentsTable from './reusable/assignments-table/AssignmentsTable.vue';
    import Discussion from './Discussion.vue';

    import moment from 'moment';
    import fileList from './reusable/files/Files.vue';
    import toastr from 'toastr';
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import hexToRgba from 'hex-to-rgba';


    import courses from '../services/courses';
    import meetings from '../services/meetings';
    import assignments from '../services/assignments';
    import aws from '../services/aws';
    import videos from '../services/videos';
    import submissions from '../services/submissions';
    import users from '../services/users';

    import { videoPlayer } from 'vue-video-player';
    require('../packages/videojs-markers');



    export default {
        data() {
            return {
                course: null,
                term: null,
                instanceId: null,
                description: null,
                lessonContent: null,
                files: null,
                assignment: null,
                instructors: null,
                rowsToShow: [],
                weekdays: [
                    {name: 'Monday', abbreviation: 'MO'},
                    {name: 'Tuesday', abbreviation: 'TU'},
                    {name: 'Wednesday', abbreviation: 'WE'},
                    {name: 'Thursday', abbreviation: 'TH'},
                    {name: 'Friday', abbreviation: 'FR'},
                    {name: 'Saturday', abbreviation: 'SA'},
                    {name: 'Sunday', abbreviation: 'SU'}
                ],
                nextMeeting: {},
                meetings: null,
                groups: null,
                submitting: false,
                selectedFeedback: null,
                videos: null,
                comments: null,
                selectedComment: null,
                showComments: false,
                currentWeek:0,
                assignments: null,
                weeks: null,
                events:[],
                termMarks: null
            }
        },
        components: {
            'course-countdown': courseCountdown,
            'assignment-countdown': assignmentCountdown,
            'file-list': fileList,
            'video-player': videoPlayer,
            'video-comment': videoComment,
            'discussion': Discussion,
            'feedback': feedback,
            'timeline': timeline,
            'discussion': Discussion,
            'assignments-table': assignmentsTable,
            VuePerfectScrollbar
        },
        mounted() {
            var self = this;

            this.courseId = this.$route.params.courseId;
            this.instanceId = this.$route.params.instanceId;
            this.getTerm();
            this.getGroups().then(function() {
                self.getMeetings();
            });
            this.getVideos();
            this.getAssignments();


            var forceCloseLoader = function() {
                self.$store.dispatch('toggle',{type:'loading', boolean: false});
            }

            var handle = setInterval(function() {
                if (self.$store.getters.loading == true) {
                    forceCloseLoader();
                } else {
                    clearInterval(handle)
                }
            },2000)


        },

        methods: {
            meetingForWeek(week) {
                const term = this.$store.getters.currentTerm;
                let weekStart = moment(term.startDate).add(week - 1, 'weeks').startOf('week');
                const weekEnd = weekStart.clone().endOf('week').toDate();
                weekStart = weekStart.toDate();

                const meeting = this.meetings.find((m)=>{
                    const d = new Date(m.startTime);
                    return d > weekStart && d < weekEnd;
                });
                if (meeting) return meeting;

                return null;
            },
            backgroundColor(color, row) {
                if (!color) color = '#2c2c2c';

                if (this.rowsToShow.indexOf(row) > -1) {
                    color = hexToRgba(color, '0.5');
                }
                return color;

            },
            async getMarks() {
                const marksData = await users.getMarks(localStorage.user_id);
                if (marksData.data.metrics) {
                    const term = this.$store.getters.currentTerm
                    const marks = marksData.data.metrics;
                    const termMarks = marks.find(m => m.termId === term.id);
                    if (termMarks && termMarks.marks.assignments) {
                        this.termMarks = termMarks.marks.assignments.assignments;
                    }

                }
            },
            async getAssignments() {
                this.assignments = null;

                await this.getMarks();

                var self = this;
                assignments.get(this, this.courseId, this.instanceId).then(function(response) {
                    var courseAssignments = response.data;

                    let assignmentIds = courseAssignments.map(function(a) { return a.id});

                    if (assignmentIds.length === 0) return;

                    submissions.getMine(this, assignmentIds).then(function(res) {
                        res.data.submissions.forEach(function(submission) {
                            let index = courseAssignments.findIndex(function(a) { return a.id == submission.assignmentId})
                            if (index > -1) {
                                if (!courseAssignments[index].submissions) {
                                    courseAssignments[index].submissions = [];
                                }
                                courseAssignments[index].submissions.push(submission);
                            }
                        });
                        if (self.termMarks) {
                            for (const assignment of courseAssignments) {
                                const markedAssignment = self.termMarks.find(m => m.submission && m.submission.assignmentId === assignment.id);

                                if (markedAssignment) {
                                    assignment.submissions[0].grade = markedAssignment.submission.grade;
                                }

                            }
                        }
                        self.assignments = courseAssignments;
                    });

                });
            },
            playFeedback(week) {
                let index = this.assignments.findIndex(function(a) { return a.week === week});
                let hasFeedback = this.assignments[index].submissions.filter(function(s) {
                    return s.feedback;
                })
                let url = hasFeedback[0].feedback.body;
                this.$bus.$emit('playFeedback', url);
            },
            hasAssignment(week) {
                let index = this.assignments.findIndex(function(a) { return a.week === week});
                if (index === -1) return false;
                return true
            },
            hasFeedback(week) {
                let index = this.assignments.findIndex(function(a) { return a.week === week});
                if (index === -1) return false;
                let assignment = this.assignments[index];

                if (!assignment.submissions || assignment.submissions.length < 1) return false;

                let feedbackRecorded = assignment.submissions.filter(function(s) {
                    return s.feedback;
                });

                if (feedbackRecorded.length > 0) return true;

                return false;
            },

            toggleRow(row) {
                let i = this.rowsToShow.indexOf(row);

                if (i > -1) {
                    this.rowsToShow.splice(i, 1);
                } else {
                    this.rowsToShow.push(row);
                }

            },
            videoForWeek(week) {
                var index = this.videos.findIndex(function(v) {
                    return v.week === week
                });
                if (index === -1) return {id:0}
                return this.videos[index];
            },
            submitAssignment(assignment) {
                this.assignment = assignment;
            },


            isCurrentDay(weekday) {
                if (weekday === moment().format('dd').toUpperCase()) return true;
                return false;
            },
            dayBackground(weekday) {
                var today = moment().format('dd').toUpperCase();
                if (today === weekday) return 'today';

                today = moment().isoWeekday();
                var otherDay = moment(weekday, 'dd').isoWeekday();
                if (otherDay < today) return 'past';
                else return 'future';
            },
            hasEvent(day) {
                var index = this.events.findIndex(function(e) { return moment(e.alertDate).format('dd').toUpperCase() === day});
                return index > -1;

            },
            event(day) {
                var index = this.events.findIndex(function(e) { return moment(e.alertDate).format('dd').toUpperCase() === day});
                return this.events[index];
            },
            goToEvent(event) {
                if (event.type === 'assignment') {
                    var videoId = this.videoForWeek(this.currentWeek).id;
                    this.$router.push('/videos/' + this.instanceId + '/' + videoId + '?week=' + this.currentWeek + '&tab=assignment')
                }
            },

            isThisWeek(d) {
                var oneWeekFromNow = moment().add(7, 'days').startOf('day');
                return moment(d).isBefore(oneWeekFromNow);
            },
            weekPosition(week) {
                var currentWeek = this.currentWeek + 1;

                if (week === currentWeek) return 'this-week';
                if (week < currentWeek) return 'past';
                if (week > currentWeek) return 'future';
            },
            getGroups() {
                var self = this;

                return new Promise(function(resolve, reject) {
                    users.getGroups(this).then(function(response) {
                        self.groups = response.data.groups;
                        resolve();
                    });
                })
            },
            getMeetings() {
                var self = this;

                let studentGroups = localStorage.group.split(',').map(function(i) { return parseInt(i)});
                let currentTerm = this.$route.params.termId;
                let currentTermGroup = this.groups.find(function(g) {
                    if (g.term == currentTerm ) {
                    }
                    return g.term == currentTerm && studentGroups.indexOf(g.id) > -1
                });
                if (currentTermGroup) {
                    meetings.get(this, currentTermGroup.id).then(function(response) {
                       self.meetings = response.data.meetings.sort(function(a, b) { return new Date(a.startTime) - new Date(b.startTime)});
                    });
                } else {
                    self.meetings = [];
                }
            },
            // getMeetings() {
            //     var self = this;
            //     meetings.get(self, parseInt(localStorage.group)).then(function(response) {
            //         self.meetings = response.data.meetings.sort(function(a, b) { return new Date(a.startTime) - new Date(b.startTime)});
            //     }).catch(function(e) {
            //         self.meetings = []
            //     })
            // },
            getVideos() {
                var self = this;
                videos.get(self, self.courseId, self.instanceId).then(function(response) {
                    let instructors = [];
                    response.data.forEach(function(video) {
                        let instructor = video.instructorName;
                        if (instructors.indexOf(instructor) === -1) instructors.push(instructor);
                        self.instructors = instructors.join(' / ');
                    });

                    self.videos = response.data;
                });
            },
            getTerm() {
                var self = this;
                terms.get(this).then(function(response) {
                    self.term = response.data.terms.find(function(t) { return t.id == self.$route.params.termId});
                    self.weeks = 16;
                    //self.weeks = moment(self.term.endDate).diff(moment(self.term.startDate), 'week') - 1;
                    //self.weeks = moment(self.term.endDate).diff(moment(self.term.startDate), 'week');
                    self.getCourse();
                });
            },
            getCourse() {
                var self = this;

                self.rowsToShow = [];

                courses.get(self, self.courseId).then(function(response) {
                    self.course = response.data;
                    var data = {
                        type: 'singleCourse',
                        data: response.data
                    }
                    self.$store.dispatch('populate', data)


                    if (!Array.isArray(response.data)) response.data = [response.data];

                    var index = self.videos.findIndex(function(d) { return d.week === self.currentWeek});
                    self.toggleRow(index);

                    var data = {
                        type: 'meetings',
                        data: response.data
                    }

                    self.$store.dispatch('populate', data)

                });

            },

            isUpcoming(assignment) {
                var due = assignment.time_due;
                if (typeof due !== 'string') return;

                due = moment(due);
                var now = new Date();

                var duration = moment.duration(moment(due).diff(moment(now)));
                if (duration.milliseconds < 4.32e+8) return true;
            },
            isToday(time) {
                if (moment(time).local().toDate().toDateString() === new Date().toDateString()){
                    return true;
                }
                return false;
            },
            submissionDatePassed(date) {
                return new Date() > new Date(date);
            }
        },
        watch: {
            '$route': function() {
                this.courseId = this.$route.params.courseId;
                this.instanceId = this.$route.params.instanceId;

                this.getCourse();
                this.getVideos();
                this.getAssignments();
            },
            currentWeek: function(week) {
                var self = this;
                if (this.videos) {
                    var index = this.videos.findIndex(function(d) { return d.week === week});
                    self.toggleRow(index);
                }
            }
        },
        computed: {

            weekChange() {
                this.currentWeek = this.$store.getters.currentWeek + 1;
            },


            timelineEvents() {
                var self = this;
                if (!self.videos) return;
                this.events = this.$store.getters.timelineEvents.filter(function(e) {
                    if (!e) return;

                    let date;
                    e.type === 'meeting' ? date = new Date(e.startTime) : date = new Date(e.dueDate);
                    return date <= moment().endOf('week').add(1,'day').toDate() && date > moment().startOf('week').add(1,'day').toDate();
                }).filter(function(e) {
                    if (!e) return;
                    if (e.type === 'meeting') return true;
                    if (e.type === 'assignment') {
                        return e.instanceId = self.instanceId;
                    }

                    if (e.type === 'exercise') {
                        if (!e.exercise) return false;
                        let index = self.videos.findIndex(function(v) { return v.id === e.exercise.videoId});
                        return index > -1;
                    }
                });

            },
        }
    }

</script>


<style lang="scss" scoped>



    .live-session-thumbnail {
        text-align:center;
        a {
            width:100%;
            display:inline-block;
            margin-top:2rem;

            padding:0;
        }
        img {
            pointer-events: none;
        }
        img.thumbnail {
            position:relative;
            margin:0;
        }
        img.play-button {
            width:35px;
            height:35px;
            margin-top:2rem;
            position:absolute;
            display:block;
            cursor:pointer;
            top:2rem;left:0;right:0;bottom:0;margin:auto;
        }
    }

    .scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height:355px;
    }

    .instructor-name {
        font-size:20px;
        color: white;
        font-weight:100;
        margin-left: 5px;
    }

    .course-description {
        padding:2rem 2rem 2rem 0;
        margin-left: 5px;
        white-space:pre-wrap;
    }


    h1 {
        margin-top: -48px;
        margin-bottom: 15px !important;
        pointer-events: none;
        .week-number {
            background:#363636;
            font-size:4rem;
            display:inline-block;
            padding:0 1rem;
            margin-right:.25rem;
        }
    }

    .description {
        white-space: pre-wrap;
        margin-top:15px;
        font-size:13px;
        line-height: 21px;
        padding: 0.5rem 10px 20px 10px;
    }

    .course-weeks {
        a {
            cursor:pointer;
            &.inactive {
                cursor:default;
                text-decoration:none;
            }
        }
        .current-week {
            background:#222222;
            color:white;
            h4 {
                color:white;
            }
        }
        li {
            display:flex;
            width:100%;
            padding: 1rem 0;
            clear:both;
            background:#2c2c2c;
            border-bottom: 1px solid #5d5d5d;
            font-size:14px;
            font-weight:100;
            a {
                color:#fff;
            }
            h4 {
                font-size:14px;
                color:#b0b0b0;
                margin:0;
                padding-left: 10px;
                padding-right: 10px;
                padding-top: .5rem;
                //padding:0;
                font-weight:500;
                position:relative;
                top:3px;
                font-weight: 400;
            }
        }
        .view-video {
            width:35px;
            height:35px;
            margin-right:1rem;
            cursor:pointer;
            &.inactive {
                cursor:default;
            }
        }
        .video-thumbnail {
            margin-top:2rem;
            max-height: 95px;
            display: block;
            overflow: hidden;
            cursor: pointer;
            &.live-session .thumbnail {
                border:none;
                border-radius:0;
                background:transparent;
            }
        }
    }
    .live-session .play-button {
        pointer-events: none;
    }

    #course-weeks div[class^='col-'] {
        padding-left: 10px;
        padding-right: 10px;
        border-right: 1px solid #5d5d5d;
        //padding:50px 0px;
    }
    #course-weeks div:last-child {
        border-right:none;
    }

    /*#course-weeks .col-md-1 {
       padding-left: 10px;padding-right: 10px;
       }*/


    .forum {
        margin-top:3rem;
        //background: #0c0c0c;
    }

    .VueCarousel {
        //min-height: 150px;
    }

    .pin {
        width:27px;
        height:75px;
        background-size:100% 100%;
        background-repeat: no-repeat;
        display:inline-block;
        position:absolute;
        top:-25px;
        &.session {
            background-image:url('../assets/img/session-pin.png');
        }
        &.assignment {
            background-image:url('../assets/img/assignment-pin.png');
        }
        &.exercise {
            background-image:url('../assets/img/exercise-pin.png');
        }
    }
    .events {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: space-between;
        align-items: center;
    }

    .videos {
        li {
            text-align: center;
            border-bottom: 1px solid #666666;
            a {
                text-decoration: none;
                color:#fff;
            }
            color:#fff;
            &.this-week {
                font-weight:400;
                background: #363636;
                a {
                    color:#33ccff!important;
                }
            }
            &.past {
                background: #1c1c1c;
                color:#ccc;
                a {
                    color:#ccc;
                }
            }
            &.future {
                background: #2c2c2c;
                color:#919191;
                a {
                    color:#919191;
                }
            }
            div {
                max-height: 6rem;
            }
            div:first-child {
                //padding:2rem 1rem;
            }
            div:nth-child(2) {
                //padding:2rem 1rem;
            }
            div:last-child {
                a {
                    display:inline-block;
                    //padding:2rem 1rem;
                    width:100%;
                }

            }
            &:last-of-type {
                border-bottom:none;
            }
        }
    }

    .week-at-a-glance {
        .panel-heading  {
            //transform:translateX(-1.4rem);
            //width:calc(100% + 1.4rem)
        }
    }

    .week-at-a-glance ul {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: center;
        align-content: space-between;
        align-items: center;
        max-width:95%;
        float:none;
        margin:3rem auto;
        margin-top:3rem;
        li {
            list-style-type:none;
            height:48px;
            line-height: 48px;
            font-size:17px;
            border-left:1px solid #464545;
            border-right:1px solid #464545;
        }
        li:first-child {
            border-left:2px solid #464545;
        }
        li:last-child {
            border-right:2px solid #464545;
        }
    }
    .weekday {
        position:relative;
        flex: 0.5 1 auto;
        color: #535353;
        font-weight:200;
        &.today {
            flex: 2 1 auto;
            color:#fff;
            background: #363636;
        }
        &.past {
            background:#1c1c1c;
            color:#ccc;
        }
        &.future {
            background:#2c2c2c;
            color:#919191;
        }
    }
    .video-wrapper {
        position: relative;
    }
    // .selected-comment {
        //     position: absolute;
        //     top:0;
        //     right:0;
        //     z-index:99999999;
        //     padding:2rem;
        //     background:rgba(20,20,20,.85);
        //     color:#fafafa;
        //     font-size:1.6rem;
        //     font-weight:400;
        //     .close {
            //         cursor:pointer;
            //         position:absolute;
            //         top:.5rem;
            //         right:.5rem;
            //         font-size:2rem;
            //         color:#42b983;
            //     }
        // }
    .show-comments {
        padding: 2rem 0;
        button {
            display: inline-block;
            padding: 5px 14px;
            background-color: #00bc8c;
            border: 1px solid transparent;
            border-radius: 15px;
            color:#fff;
            &:active {
                border:none;
                box-shadow: none;
                outline: none;
            }
        }
    }
    h1 {
        font-size:3rem;
        font-weight:400;
        margin-bottom:3rem;
    }

    .scroll-area {
        margin-bottom:30px;
    }


    .assignments {
        h2 img {
            margin-right:1rem;
        }
    }



</style>
<style lang="scss">


    .ps__scrollbar-y-rail {
        opacity:1!important;
    }
    .ps__scrollbar-y {
        background:#1a1a1a!important;
        border-radius:0!important;
        width:10px!important;
        right: 0!important;
        width: 10px!important;
    }
    .video-scroll {
        position: relative;
        margin: auto;
        max-height: 328px;
    }

    .replies ul:first-child > li {
        padding-left:0;
    }
    li.discussion {
        padding-bottom:2rem;
    }
    img, video {
        max-width:100%;
    }

    .VueCarousel-inner {
        // max-width:300px;
        padding:2rem;
        h4 {
            text-align:center;
            font-weight:200;
            margin-bottom:2rem;
            margin-right: 40px;
        }
        p {
            max-width:90%;
        }
        .past, .future {
            background:transparent!important;
        }
    }
    .VueCarousel-navigation {
        position: absolute;
        top: 3rem;
        z-index: 9999999999;
        width: 100%;
    }
    .VueCarousel-navigation-next, .VueCarousel-navigation-prev  {
        background-size: 100% 100%;
        background-repeat:no-repeat;
        width: 11px;
        height: 28px;
        &::after {
            display:none;
        }
    }
    .VueCarousel-navigation-next {
        transform:  translateX(-300%)!important;
        background-image: url('../assets/img/next-arrow.png');

    }
    .VueCarousel-navigation-prev {
        transform:  translateX(300%)!important;
        background-image: url('../assets/img/previous-arrow.png');

    }
    .has-course-table.panel {
        padding:0!important;
        //margin-top:2rem;
        .panel-body {
            padding:0;
        }
        h2 {
            width:250px;
        }
        .panel-heading {
            //transform: translate(10px, -25px);
        }
        .col-xs-2,.col-xs-4,.col-xs-6 {display:table;height:200px;}
        .vert-align {display:table-cell;vertical-align:middle;}
    }

    .course-table {
        width:100%;
        &.has-header {
            margin-top:-3.8rem;
        }
        thead {
            margin-top:-2rem;
        }
        th, td {
            text-align:center;
            padding:2rem;

        }
        th {
            //border-left:1px solid #666666;
            //border-right:1px solid #666666;
        }
        td {
            //border:1px solid #666666;
        }
        tr {border-bottom:1px solid #666666;
        }

    }

    .week-at-a-glance {
        margin-bottom: 0px!important;
    }

    .this-week {
        background: #363636 !important;
        color:#fff!important;
        a {
        }
    }
    .past {
        background: #1c1c1c!important;
        color:#ccc!important;
        a {
            color:#ccc!important;
        }
    }
    .future {
        background: #2c2c2c!important;
        color:#919191;
    }

    .weeks .future {
        background:none!important;
    }
    div.toggle-week {
        margin-left:20px;
        width:10%;
        font-size: 14px;
        white-space: nowrap;
        padding-top:.5rem;
        cursor:pointer;
        i {
            font-size:1rem!important;
        }
        i:before {
            margin-right:5px;
            margin-left:-5px;
        }
    }
</style>



// WEBPACK FOOTER //
// Course.vue?527c5932